module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "overflow-x": "auto",
      "clear": "both"
    }
  }, [_c('table', {
    staticClass: "table table-striped",
    class: {
      'table-hover': _vm.rowClickable == true
    }
  }, [_c('thead', [_c('tr', [_vm._l((_vm.fields), function(field) {
    return _c('th', [_vm._v(_vm._s(field.label))])
  }), _vm._v(" "), (_vm.hasEdit || _vm.hasDelete) ? _c('th') : _vm._e()], 2)]), _vm._v(" "), _c('tbody', [_vm._l((_vm.mutatedRecords), function(record) {
    return _c('tr', {
      on: {
        "click": function($event) {
          _vm.editRecord(record, 'row')
        }
      }
    }, [_vm._l((_vm.fields), function(field) {
      return _c('td', [_vm._v("\n                    " + _vm._s(record[field.key]) + "\n                ")])
    }), _vm._v(" "), (_vm.hasEdit || _vm.hasDelete) ? _c('td', {
      staticStyle: {
        "min-width": "90px"
      }
    }, [_vm._l((_vm.otherButtons), function(button) {
      return (_vm.otherButtons) ? _c('div', {
        staticClass: "other-buttons"
      }, [_c('router-link', {
        staticClass: "btn btn-sm",
        class: button.class,
        staticStyle: {
          "margin-left": "4px"
        },
        attrs: {
          "to": button.link + record.id
        }
      }, [(button.icon) ? _c('i', {
        staticClass: "fa",
        class: button.icon
      }) : _vm._e(), _vm._v("\n                            " + _vm._s(button.text) + "\n                        ")])], 1) : _vm._e()
    }), _vm._v(" "), (_vm.hasEdit == true) ? _c('button', {
      staticClass: "btn btn-default btn-sm",
      on: {
        "click": function($event) {
          _vm.editRecord(record, 'button')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })]) : _c('router-link', {
      staticClass: "btn btn-default btn-sm",
      attrs: {
        "to": record.editUrl
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })]), _vm._v(" "), (_vm.hasDelete) ? _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          _vm.deleteRecord(record)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-remove"
    })]) : _vm._e()], 2) : _vm._e()], 2)
  }), _vm._v(" "), (_vm.mutatedRecords.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": _vm.fields.length
    }
  }, [_vm._v("No records")]), _vm._v(" "), (_vm.hasEdit || _vm.hasDelete) ? _c('td') : _vm._e()]) : _vm._e()], 2)]), _vm._v(" "), (_vm.confirmDialog.visible) ? _c('modal-dialog', {
    attrs: {
      "title": _vm.confirmDialog.title,
      "modal-visible": _vm.confirmDialog.visible,
      "confirm-button-text": _vm.confirmDialog.buttonText,
      "button-class": _vm.confirmDialog.buttonClass
    },
    on: {
      "confirm": function($event) {
        _vm.executeDelete(_vm.confirmDialog.parameters)
      },
      "closeModal": function($event) {
        _vm.confirmDialog.visible = false
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.confirmDialog.message) + "\n    ")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21c9e80d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TableList.vue
// module id = 275
// module chunks = 0